<template>
    <div style="height:100vh" class="flex flex-column">
        <custom-header></custom-header>
        <div class="layout-wrapper flex">
            <custom-sidebar></custom-sidebar>
            <div class="layout-content">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import customHeader from '@/components/layout/custom-head.vue';
import customSidebar from '@/components/layout/custom-sidebar.vue';

//导入draggable组件
export default {
    name: "Layout",
    components: { customHeader,customSidebar },
    props: {

    },
    data() {
        return {
           
        }
    },
    computed:{
        ...mapState(['meetingInfo']),
    },
     methods:{
        
    },
    mounted(){
    }
}
</script>

<style lang="less" scoped>
.layout-wrapper{
    height:calc(100vh - 60px);
}
.layout-content{
    height:100%;
    background: #f5f6f9;
    width:calc(100% - 80px);
    overflow: auto;
}
</style>